import Link from 'next/link';

export default function UtilityBar() {
  return (
    <div className="w-full h-9 bg-[#1A1A1A] hidden md:flex items-center justify-between px-5 shrink-0">
      <div className="flex items-center gap-0">
        <select
          className="bg-transparent text-[#BBBBBB] font-[IBM_Plex_Sans,system-ui,sans-serif] text-[11px] tracking-[0.03em] border-none outline-none cursor-pointer pr-4 appearance-none"
          defaultValue="global"
        >
          <option value="global">🌐 Global Edition</option>
          <option value="uk">🇬🇧 UK Edition</option>
          <option value="us">🇺🇸 US Edition</option>
          <option value="eu">🇪🇺 Europe Edition</option>
          <option value="as">🌏 Asia Edition</option>
        </select>
        <span className="text-[#555] mx-3 text-[11px]">|</span>
        <button className="text-[#BBBBBB] text-[11px] tracking-[0.03em] hover:text-white transition-colors font-[IBM_Plex_Sans,system-ui,sans-serif]">
          Language
        </button>
        <span className="text-[#555] mx-3 text-[11px]">|</span>
        <Link href="/about" className="text-[#BBBBBB] text-[11px] tracking-[0.03em] hover:text-white transition-colors font-[IBM_Plex_Sans,system-ui,sans-serif]">
          About
        </Link>
        <span className="text-[#555] mx-3 text-[11px]">|</span>
        <button className="text-[#BBBBBB] text-[11px] tracking-[0.03em] hover:text-white transition-colors font-[IBM_Plex_Sans,system-ui,sans-serif]">
          Accessibility
        </button>
      </div>
      <div className="flex items-center gap-0">
        <Link href="/newsletters" className="text-[#BBBBBB] text-[11px] tracking-[0.03em] hover:text-white transition-colors font-[IBM_Plex_Sans,system-ui,sans-serif]">
          Newsletters
        </Link>
        <span className="text-[#555] mx-3 text-[11px]">|</span>
        <button className="text-[#BBBBBB] text-[11px] tracking-[0.03em] hover:text-white transition-colors font-[IBM_Plex_Sans,system-ui,sans-serif]">
          Podcasts
        </button>
        <span className="text-[#555] mx-3 text-[11px]">|</span>
        <button className="text-[#BBBBBB] text-[11px] tracking-[0.03em] hover:text-white transition-colors font-[IBM_Plex_Sans,system-ui,sans-serif]">
          App
        </button>
        <span className="text-[#555] mx-3 text-[11px]">|</span>
        <button className="text-[#BBBBBB] text-[11px] tracking-[0.03em] hover:text-white transition-colors font-[IBM_Plex_Sans,system-ui,sans-serif]">
          Sign In
        </button>
      </div>
    </div>
  );
}
